/**
 * StatCard Component
 * Glass-morphism stat card for the My Rituality dashboard
 * Displays a label, value, and description text
 */

import { cn } from "@/lib"

interface StatCardProps {
  label: string
  value: string
  description: string
  className?: string
}

export function StatCard({ label, value, description, className }: StatCardProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-2.5 items-start p-5 rounded-[20px]",
        "bg-white/5 border border-white/10 overflow-hidden",
        className,
      )}
    >
      <span className="text-sm font-semibold uppercase opacity-50 text-primary w-full">
        {label}
      </span>
      <span className="text-xl font-semibold leading-[30px] opacity-90 text-primary">{value}</span>
      <p className="text-[13px] font-normal leading-5 opacity-50 text-primary w-full">
        {description}
      </p>
    </div>
  )
}
